import LANDINGSECTION from "./LandingConstant";
import {
  FaTh,
  FaRegChartBar,
  FaCommentAlt,
  FaShoppingBag,
  FaRocket,
} from "react-icons/fa";
import ReleaseV0 from "../components/ReleasePage/Versions/ReleaseV0";
import ReleaseV1 from "../components/ReleasePage/Versions/ReleaseV1";
import ReleaseV2 from "../components/ReleasePage/Versions/ReleaseV2";
import ReleaseV3 from "../components/ReleasePage/Versions/ReleaseV3";
import ReleaseV4 from "../components/ReleasePage/Versions/ReleaseV4";
import ReleaseV5 from "../components/ReleasePage/Versions/ReleaseV5";
import ReleaseV6 from "../components/ReleasePage/Versions/ReleaseV6";

export const DATABOOK_LOGO = LANDINGSECTION.NAVIMG.DATABOOK;
export const SETTINGS_ICON = LANDINGSECTION.NAVIMG.SETTINGS;
export const NOTIFICATIONS_ICON = LANDINGSECTION.NAVIMG.NOTIFICATIONS;
export const HELP_ICON = LANDINGSECTION.NAVIMG.HELP;
export const WELCOME_IMG = LANDINGSECTION.LANDING_INFO.WELCOME;
export const DATASET_IMG = LANDINGSECTION.LANDING_INFO.DATASETS;
export const PRODUCTCATA_IMG = LANDINGSECTION.LANDING_INFO.PRODUCTCATA;
export const JOBCATA_IMG = LANDINGSECTION.LANDING_INFO.JOBCATA;
export const BICATA_IMG = LANDINGSECTION.LANDING_INFO.BICATA;
export const SERVICES_IMG = LANDINGSECTION.LANDING_INFO.SERVICES;
export const DATABASE_IMG = LANDINGSECTION.LANDING_INFO.DATABASE;
export const VIEWALL_IMG = LANDINGSECTION.LANDING_INFO.VIEWALL;
export const EYE_IMG = LANDINGSECTION.LANDING_INFO.EYE;
export const BUSINESS_IMG = LANDINGSECTION.LANDING_INFO.BUSINESS;
export const APMT_IMG = LANDINGSECTION.LANDING_INFO.APMT;
export const OCEAN_IMG = LANDINGSECTION.LANDING_INFO.OCEAN;
export const LNS_IMG = LANDINGSECTION.LANDING_INFO.LNS;
export const DATASETS_IMG = LANDINGSECTION.LANDING_INFO.DATASETS;
export const DATASET_LAND = LANDINGSECTION.LANDING_INFO.DATASETSLAND;
export const DOMAIN_IMG = LANDINGSECTION.LANDING_INFO.DOMAIN;
export const FINANCE_IMG = LANDINGSECTION.LANDING_INFO.FINANCE;
export const BRAND_IMG = LANDINGSECTION.LANDING_INFO.BRAND;
export const HR_IMG = LANDINGSECTION.LANDING_INFO.HR;
export const COSTCENTRE_IMG = LANDINGSECTION.LANDING_INFO.COSTCENTRE;
export const PERSON_IMG = LANDINGSECTION.LANDING_INFO.PERSON;
export const PAYROLL_IMG = LANDINGSECTION.LANDING_INFO.PAYROLL;
export const PERFORMANCE_IMG = LANDINGSECTION.LANDING_INFO.PERFORMANCE;
export const JOB_IMG = LANDINGSECTION.LANDING_INFO.JOB;
export const GEOGRAPHY_IMG = LANDINGSECTION.LANDING_INFO.GEOGRAPHY;
export const ENTITY_IMG = LANDINGSECTION.LANDING_INFO.ENTITY;
export const COMPANY_IMG = LANDINGSECTION.LANDING_INFO.COMPANY;
export const APPLICATION_IMG = LANDINGSECTION.LANDING_INFO.APPLICATION;
export const TIME_IMG = LANDINGSECTION.LANDING_INFO.TIME;
export const SUSER_IMG = LANDINGSECTION.LANDING_INFO.SYSTEMUSER;
export const RECRUITMENT_IMG = LANDINGSECTION.LANDING_INFO.RECRUITMENT;
export const CURRENCY_IMG = LANDINGSECTION.LANDING_INFO.CURRENCY;
export const MAESTRO_IMG = LANDINGSECTION.LANDING_INFO.MAESTRO;
export const DATABOOK_IMG = LANDINGSECTION.NAVIMG.DATABOOK_NAV;
export const INSIGHTS_IMG = LANDINGSECTION.NAVIMG.INSIGHTS;
export const VESSEL_IMG = LANDINGSECTION.LANDING_INFO.VESSEL;
export const TECHPLAT_IMG = LANDINGSECTION.LANDING_INFO.TECHPLATFORM;
export const RELEASE_IMG = LANDINGSECTION.LANDING_INFO.RELEASE;
export const DATACATALOG_IMG = LANDINGSECTION.LANDING_INFO.DATACATALOG;
export const SUPPORT_IMG = LANDINGSECTION.LANDING_INFO.SUPPORT;
export const FLEET_IMG = LANDINGSECTION.LANDING_INFO.FLEET;
export const FEATURE_CATALOG_IMG = LANDINGSECTION.LANDING_INFO.FEATURECATALOG;
export const DATABOOK_GPT_IMG = LANDINGSECTION.LANDING_INFO.DATABOOKGPT;
export const QUERY_GPT_IMG = LANDINGSECTION.LANDING_INFO.QUERYGPT;
export const DATABOOK_GPT_ICON = LANDINGSECTION.LANDING_INFO.DATABOOKGPTICON;
export const DATABOOK_GPT_AVATAR =
  LANDINGSECTION.LANDING_INFO.DATABOOKGPTAVATAR;
export const USER_AVATAR_IMG = LANDINGSECTION.LANDING_INFO.GPTUSERICON;

export const DATA_CATALOGUE_IMG = LANDINGSECTION.LANDING_INFO.DATA_CATALOGUE;
export const DATA_ASSISTANT_IMG = LANDINGSECTION.LANDING_INFO.DATA_ASSISTANT;

export const QUERY_GPT_ICON = LANDINGSECTION.LANDING_INFO.QUERYGPTICON;
export const FULFILLED_BY_IMG = LANDINGSECTION.LANDING_INFO.FULFILLEDBY;
export const TRANSPORTED_BY_IMG = LANDINGSECTION.LANDING_INFO.TRANSPORTEDBY;
export const BUSINESS_ENABLING_IMG =
  LANDINGSECTION.LANDING_INFO.BUSINESSENABLING;
export const CORPORATE_PLATFORM_IMG =
  LANDINGSECTION.LANDING_INFO.CORPORATEPLATFORM;
export const PLATFORM_ENABLER_IMG = LANDINGSECTION.LANDING_INFO.PLATFORMENABLER;
export const MANAGED_BY_IMG = LANDINGSECTION.LANDING_INFO.MANAGEDBY;
export const THEMIS_IMG = LANDINGSECTION.LANDING_INFO.THEMIS;
export const FEEDBACK_IMG = LANDINGSECTION.LANDING_INFO.FEEDBACK;
export const WARNING_IMG = LANDINGSECTION.LANDING_INFO.WARNING;
export const OTHERS_IMG = LANDINGSECTION.LANDING_INFO.OTHERS;
export const MASTER_DATA_IMG = LANDINGSECTION.LANDING_INFO.MASTERDATA;
export const SALES_IMG = LANDINGSECTION.LANDING_INFO.SALES;
export const DND_IMG = LANDINGSECTION.LANDING_INFO.DND;
export const CONTRACTS_IMG = LANDINGSECTION.LANDING_INFO.CONTRACTS;
export const BOOKING_IMG = LANDINGSECTION.LANDING_INFO.BOOKING;
export const HSUD_IMG = LANDINGSECTION.LANDING_INFO.HSUD;
export const SERVICE_DELIVERY_IMG = LANDINGSECTION.LANDING_INFO.SERVICEDELIVERY;
//////////these section within this slashes needs to be removed once lineage is up////////
export const LINEAGE_EQBC_IMG = LANDINGSECTION.LANDING_INFO.LINEAGE_EQBC;
export const LINEAGE_GCSS_CARGO_IMG = LANDINGSECTION.LANDING_INFO.LINEAGE_GCSS;
export const LINEAGE_GLSM_PO_IMG = LANDINGSECTION.LANDING_INFO.LINEAGE_GLSM_PO;
//////////////////////////////////////////////////////////////////////////////////
export const CERTIFIED_IMG = LANDINGSECTION.LANDING_INFO.CERTIFIED_LOGO;
export const RELEASE_URL =
  "https://maersk-tools.atlassian.net/wiki/spaces/PC/pages/182013755494/Databook+Alpha+Release+Note+-+17th+Feb+2023";

export const SUPPORT_URL =
  "https://teams.microsoft.com/l/chat/0/0?users=28:ee2b3e75-4f8f-41da-ba93-a3275630d1eb";

export const Observability_Metrics =
  "https://unravel-prod.maestro.maersk.com/#/jobs/runs";

export const POWERBI_DATAHUB = "https://app.powerbi.com/datahub";

export const POWERBI_BIM =
  "https://app.powerbi.com/groups/me/reports/172998fc-c72d-4ea6-ab2e-0234d768b989/ReportSection";

// export const DEV_CLARITY_URL =
//   "https://clarity.microsoft.com/projects/view/gtin8me22v/dashboard?date=Last%2030%20days&Source=databook-dev.maestro.maersk.com";

// export const PROD_CLARITY_URL =
//   "https://clarity.microsoft.com/projects/view/gtin8me22v/dashboard?Source=databook.maestro.maersk.com&date=Last%2030%20days";
export const FEEDBACK_FORM_URL = "https://forms.office.com/e/qXyMm8nGN7";
export const TEAMS_CHANNEL_URL =
  "https://teams.microsoft.com/l/channel/19%3Aca658371337642219ac5346c77de0d9a%40thread.tacv2/Data%20Book?groupId=0661e0ee-d58b-4a3c-b947-ae1d91a4158f&tenantId=05d75c05-fa1a-42e7-9cf1-eb416c396f2d";

export const menuItem = [
  {
    path: "/",
    name: "Home",
    icon: <FaCommentAlt />,
  },
  {
    path: "/databook/datasets",
    name: "Data Catalogue",
    icon: <FaTh />,
  },

  {
    path: "/databook/jobcatalogue",
    name: "Job Catalogue",
    icon: <FaRegChartBar />,
  },
  {
    path: "/databook/bicatalogue",
    name: "Bi Catalogue",
    icon: <FaShoppingBag />,
  },

  {
    path: "/databook/observabilitymetrics",
    name: "Observability Metrics",
    icon: <FaRegChartBar />,
  },
  {
    path: "/databook/clarity",
    name: "Insights",
    icon: <FaRegChartBar />,
  },
  {
    path: "/databook/release",
    name: "Release",
    icon: <FaRocket />,
  },
];

export const SEARCHED_PROPS_VIEWALL = ["fqn"];
export const DATASET_EXCEL_FILE = "Datasets_Excel";

export const ERRORS = {
  MSG: {
    NOTFOUND: "Not Found",
    INTERNALERROR: "Internal Server Error",
  },
};
export const qualityclr = {
  HIGH: "#40AB35",
  LOW: "#FA6A55",
  MEDIUM: "#FFD700",
};

export const RELEASE_CONST = [
  {
    VERSION_HEADER: "Alpha Releases ( V1.0.0 )",
    RELEASE_FEATURES: [
      "Landing Page",
      "Menu Bar",
      "Global Search",
      "Smart Search with Tabular View",
      "Datasets Landing Page with Widgets",
      "Details Page with columns, Preview, Utilization, Metrics and Lineage (POC)",
      "Service and Support",
    ],
  },
  {
    VERSION_HEADER: "Alpha Releases ( V1.1.0 )",
    RELEASE_FEATURES: [
      "Landing Page with new theme",
      "user behavior analytics tool as Insights in the nav bar ",
      "Support and Services",
      "Global search with enhanced features",
      "Advanced Seach",
      "Data catalog with business, domains, dataset widgets, view all etc",
      "Databook GPT",
      "Details Page with columns, Preview, Utilization, Metrics and Lineage (POC)",
    ],
  },
];

export const CATALOGUE_ITEMS = [
  "Data Catalogue",
  "Feature Catalogue",
  "Search Assistant",
  "Query Assistance",
];

export const GOVERN_ITEMS = {
  title: "Publish",
  data: [
    {
      menu: "My Connections",
      url: "/databook/myconnections",
    },
    {
      menu: "Publish Metadata",
      url: "/databook/publishMetadata",
    },
    // {
    //   menu: "Publish Lineage",
    //   url: "/databook/PublishLineage",
    // },
    {
      menu: "Manage Classification and Glossary",
      url: "/databook/tagsclassifcation",
    },
    // {
    //   menu: "Glossary",
    //   url: "/databook/glossary",
    // },
    {
      menu: "Bulk Upload Business Glossary",
      url: "/databook/bulkupload",
    },
  ],
};
// const CLARITY_URL =
//   process.env.NODE_ENV === "development" &&
//     process.env.REACT_APP_RUN_ENV === "development"
//     ? DEV_CLARITY_URL
//     : PROD_CLARITY_URL;

export const ABOUT = {
  title: "About",
  data: [
    {
      menu: "Release",
      url: "/databook/release",
    },
    // {
    //   menu: "Insights",
    //   url: `${CLARITY_URL}`,
    // }
  ],
};

/**
 * Assuming the below role as business role
 */

export const BUSINESS_ROLE = "databook-business-user";
export const TECHNO_ROLE = "databook-tech-user";

export const CLASSI_TAG_GUIDE_CONST = {
  CLASSI_HEADER:
    " This page basically consists of two different sections Tag & Classification by clicking on any Classification the Description and Classification Name with the number of tags associated will be seen above the Tabular View.",
  CLASSI_STEPS: [
    {
      list: "Create a Classification by clicking on Create Classification button in the left Classification Name is mandatory.",
    },
    {
      list: " All the Classification will be listed on the left after creating it.",
    },
    {
      list: "Edit a Classification by clicking on the icon next to the Classification Name.",
    },
    {
      list: " For Deleting a classification click on the Button Delete Classification on top right corner.",
    },
  ],
  TAG_STEPS: [
    {
      list: "To create a Tag, click on Add Tag Button on the right where you can choose classification name from the drop down where (Tag Name) is mandatory.",
    },
    {
      list: "The tags will be listed on the table.",
    },
    {
      list: "For Edit & Delete of a Tag need to Select the icons present in the Actions Column in the Table.",
    },
  ],
};

export const GLOSSARY_TERM_GUIDE_CONST = {
  GLOSSARY_HEADER:
    " This page basically consists of two different sections Tag & Glossary by clicking on any Glossary the Description and Glossary Name with the number of terms associated will be seen above the Tabular View.",
  GLOSSARY_STEPS: [
    {
      list: " Create a Glossary by clicking on Create Glossary button in the left Glossary Name is mandatory.",
    },
    {
      list: "  All the Glossary will be listed on the left after creating it.",
    },
    {
      list: " Edit a Glossary by clicking on the icon next to the Glossary Name.",
    },
    {
      list: "For Deleting a glossary click on the Button Delete Glossary on top right corner.",
    },
  ],
  TERM_STEPS: [
    {
      list: "To create a Term,selecting a Glossary Name is mandatory Then click on Add Term button on the top right corner whereTerm Name & Description is mandatory.",
    },
    {
      list: "The terms will be listed on the table.",
    },
    {
      list: " For Edit & Delete of a Term need to Select the icons present in the Actions Column in the Table.",
    },
    {
      list: "You can also create sub terms for a particular term by selecting the add icon from each row. It creates a hierarchy.You can create as many hierarchy you need on the terms.",
    },
  ],
};

export const SAVIYANT_URL =
  "https://maersk.ssmcloud.net/ECMv6/request/requestHome";

export const SAVIYANT_HELP_URL =
  "https://teamsite.maerskgroup.com/sites/SecureIdentity/SitePages/Maersk-IGA-service-instructions.aspx";

export const RELEASE_NOTES = [
  { label: "Beta_V.1.4.0", key: "beta_v.1.4.0", children: <ReleaseV6 /> },
  { label: "Beta_V.1.3.0", key: "beta_v.1.3.0", children: <ReleaseV5 /> },
  { label: "Beta_V.1.2.0", key: "beta_v.1.2.0", children: <ReleaseV4 /> },
  { label: "Beta_V.1.1.0", key: "beta_v.1.1.0", children: <ReleaseV3 /> },
  { label: "Beta_V.1.0.0", key: "beta_v.1.0.0", children: <ReleaseV2 /> },
  { label: "Alpha_V.1.1.0", key: "alpha_v.1.1.0", children: <ReleaseV1 /> },
  { label: "Alpha_V.1.0.0", key: "alpha_v.1.0.0", children: <ReleaseV0 /> },
];

export const EDA_MEMBERS = [
  "nithin.anil@maersk.com",
  "Ashwini.Kerkar@maersk.com",
  "Sephali.tripathy@maersk.com",
  "sandipan.chakraborty@maersk.com",
  "shivakumar.dorai@maersk.com",
];

export const DBK_RELEASE_URL =
  "https://docs.maersk-digital.net/blog/2024/08/26/beta1.4/";
//export const DBK_RELEASE_URL = "/databook/release";
export const NOTI_MSG =
  "Announcing Version Beta v1.4.0 Loaded with Fresh Features! Discover more";

export const EDIT_SENSITIVITY_DATABOOK_USER = [
  "ashwini.kerkar@maersk.com",
  "shivakumar.dorai@maersk.com",
  "sandipan.chakraborty@maersk.com",
  "sephali.tripathy@maersk.com",
  "pradeep.panigrahi@maersk.com",
  "tarun.kumar2020@maersk.com",
];

export const EDIT_SENSITIVITY_DATAEXCELLENCE_USER = [
  "prasun.nesu@maersk.com",
  "anita.sharma.1@maersk.com",
  "snehal.s.shinde@maersk.com",
];

export const EXCLUDE_COLUMN = ["version_no"];

export const BI_PRODUCT_FLAG = "BI Product";

export const DP_DASHBOARD = "DASHBOARD_REPORT";

export const DP_KPMETRIC = "KP_METRIC";

export const TREE_DATA_JSON = [
  {
    title: "Dataset",
    value: "dataset",
    key: "dataset",
    selectable: false,
    children: [
      {
        title: "Dataset-Name",
        value: "dataset-name",
        key: "dataset-name",
      },
      {
        title: "Dataset-Description",
        value: "dataset-desc",
        key: "dataset-desc",
      },
      {
        title: "Dataset-Tag",
        value: "dataset-tag",
        key: "dataset-tag",
      },
      {
        title: "Column-Name",
        value: "column-name",
        key: "column-name",
      },
      {
        title: "Column-Description",
        value: "column-desc",
        key: "column-desc",
      },
      // {
      //   title: "Dataset-Classification",
      //   value: "dataset-classification",
      //   key: "dataset-classification",
      // },
      // {
      //   title: "Dataset-Sensitivity",
      //   value: "dataset-sensitivity",
      //   key: "dataset-sensitivity",
      // },
    ],
  },
  // {
  //   title: "Column",
  //   value: "column",
  //   key: "column",
  //   selectable: false,
  //   children: [
  //     {
  //       title: "Column-Name",
  //       value: "column-name",
  //       key: "column-name",
  //     },
  //     {
  //       title: "Column-Description",
  //       value: "column-desc",
  //       key: "column-desc",
  //     },
  //     {
  //       title: "Column-Tag",
  //       value: "column-tag",
  //       key: "column-tag",
  //     },
  //     {
  //       title: "Column-Classification",
  //       value: "column-classification",
  //       key: "column-classification",
  //     },
  //     {
  //       title: "Column-Sensitivity",
  //       value: "column-sensitivity",
  //       key: "column-sensitivity",
  //     },
  //   ],
  // },
  // {
  //   title: "Metric",
  //   value: "metric",
  //   key: "metric",
  //   selectable: false,
  //   children: [
  //     {
  //       title: "Metric-Name",
  //       value: "metric-name",
  //       key: "metric-name",
  //     },
  //     {
  //       title: "Metric-Description",
  //       value: "metric-desc",
  //       key: "metric-desc",
  //     },
  //     {
  //       title: "Metric-Tag",
  //       value: "metric-tag",
  //       key: "metric-tag",
  //     },
  //     // {
  //     //   title: "Metric-Classification",
  //     //   value: "metric-classification",
  //     //   key: "metric-classification",
  //     // },
  //     // {
  //     //   title: "Metric-Sensitivity",
  //     //   value: "metric-sensitivity",
  //     //   key: "metric-sensitivity",
  //     // },
  //     // {
  //     //   title: "Metric-Col-Name",
  //     //   value: "metric-col-name",
  //     //   key: "metric-col-name",
  //     // },
  //     // {
  //     //   title: "Metric-Col-Description",
  //     //   value: "metric-col-desc",
  //     //   key: "metric-col-desc",
  //     // },
  //     // {
  //     //   title: "Metric-Col-Tag",
  //     //   value: "metric-col-tag",
  //     //   key: "metric-col-tag",
  //     // },
  //     // {
  //     //   title: "Metric-Col-Classification",
  //     //   value: "metric-col-classification",
  //     //   key: "metric-col-classification",
  //     // },
  //     // {
  //     //   title: "Metric-Col-Sensitivity",
  //     //   value: "metric-col-sensitivity",
  //     //   key: "metric-col-sensitivity",
  //     // },
  //   ],
  // },

  // {
  //   title: "All",
  //   value: "all",
  //   key: "all",
  // },
];

// export const METRIC_STORE_CRITERIA_JSON = [
//   {
//     title: "Metric store",
//     value: "metricstore",
//     key: "metricstore",
//     selectable: false,
//     // children: [
//     //   {
//     //     key: "metric-1",
//     //     title: "Metric option 1",
//     //     value: "metric-1",
//     //   },
//     //   {
//     //     key: "metric-2",
//     //     title: "Metric option 2",
//     //     value: "metric-2",
//     //   },
//     //   {
//     //     key: "metric-3",
//     //     title: "Metric option 3",
//     //     value: "metric-3",
//     //   },
//     //   {
//     //     key: "metric-4",
//     //     title: "Metric option 4",
//     //     value: "metric-4",
//     //   },
//     // ],
//     children: [
//       {
//         title: "Metric-Name",
//         value: "metric-name",
//         key: "metric-name",
//       },
//       {
//         title: "Metric-Description",
//         value: "metric-desc",
//         key: "metric-desc",
//       },
//       {
//         title: "Metric-Tag",
//         value: "metric-tag",
//         key: "metric-tag",
//       },
//       {
//         title: "Metric-Classification",
//         value: "metric-classification",
//         key: "metric-classification",
//       },
//       {
//         title: "Metric-Sensitivity",
//         value: "metric-sensitivity",
//         key: "metric-sensitivity",
//       },
//       {
//         title: "Metric-Col-Name",
//         value: "metric-col-name",
//         key: "metric-col-name",
//       },
//       {
//         title: "Metric-Col-Description",
//         value: "metric-col-desc",
//         key: "metric-col-desc",
//       },
//       {
//         title: "Metric-Col-Tag",
//         value: "metric-col-tag",
//         key: "metric-col-tag",
//       },
//       {
//         title: "Metric-Col-Classification",
//         value: "metric-col-classification",
//         key: "metric-col-classification",
//       },
//       {
//         title: "Metric-Col-Sensitivity",
//         value: "metric-col-sensitivity",
//         key: "metric-col-sensitivity",
//       },
//     ],
//   },
// ];

export const GLOBAL_SEARCH_ACTION = "NAV_GLOBAL_SEARCH_BUTTON";
export const VIEW_ALL_ACTION = "VIEW_ALL_BUTTON";

export const OBSERVABILITY_USERS = [
  'shreedhar.selvam@maersk.com',
  'gaurav.mahajan@maersk.com',
  'sachin.shenoy@maersk.com',
  'mohit.sethi@maersk.com',
  'simran.suri@maersk.com',
  'shivakumar.dorai@maersk.com',
  'tarun.kumar2020@maersk.com',
  'pradeep.panigrahi@maersk.com'
];
